import { render, staticRenderFns } from "./ReferralCharts.vue?vue&type=template&id=481694be&"
import script from "./ReferralCharts.vue?vue&type=script&lang=ts&"
export * from "./ReferralCharts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports